<template>
  <div class="container">
    <div class="wrap box-shadow">
      <div class="row align-items-center img-panel">
                <div class="col text-center my-3">
                    <p>{{ msg }}</p>
                </div>
            </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tip',
  data() {
    return {
      msg: this.$t('share.link.delete_tip')
    }
  }
}
</script>

<style lang="scss" scoped>
.img-panel {
  min-height: 400px;
  p {
    font-weight: 900;
  }
}
</style>